/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {WorkspaceDetails} from '../models/WorkspaceDetails';
import type {WorkspaceRequest} from '../models/WorkspaceRequest';
import type {WorkspaceSearchResult} from '../models/WorkspaceSearchResult';

export interface GetUserWorkspaces$Request {
    userId: number;
    workspaceRequest: WorkspaceRequest;
}

export interface GetUserWorkspaces$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserWorkspacesRequest = createAction<PayloadData<void, GetUserWorkspaces$Request>>('USER_WORKSPACES__GET_USER_WORKSPACES__REQUEST');
export const getUserWorkspacesSuccess = createAction<PayloadData<WorkspaceSearchResult, GetUserWorkspaces$Request>>('USER_WORKSPACES__GET_USER_WORKSPACES__SUCCESS');
export const getUserWorkspacesFailure = createAction<PayloadData<Error, GetUserWorkspaces$Request, true>>('USER_WORKSPACES__GET_USER_WORKSPACES__FAILURE');

export const getUserWorkspacesActions = [
    getUserWorkspacesRequest,
    getUserWorkspacesSuccess,
    getUserWorkspacesFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {WorkspaceRequest} meta.workspaceRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserWorkspaces = (meta: GetUserWorkspaces$Request, config?: GetUserWorkspaces$Config) => {
    return {
        CALL_API: {
            types: getUserWorkspacesActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/${meta.userId}/workspaces`,
            TRANSPORT_REQUEST_BODY: meta.workspaceRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetWorkspaceById$Request {
    userId: number;
    workspaceId: number;
}

export interface GetWorkspaceById$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getWorkspaceByIdRequest = createAction<PayloadData<void, GetWorkspaceById$Request>>('USER_WORKSPACES__GET_WORKSPACE_BY_ID__REQUEST');
export const getWorkspaceByIdSuccess = createAction<PayloadData<WorkspaceDetails, GetWorkspaceById$Request>>('USER_WORKSPACES__GET_WORKSPACE_BY_ID__SUCCESS');
export const getWorkspaceByIdFailure = createAction<PayloadData<Error, GetWorkspaceById$Request, true>>('USER_WORKSPACES__GET_WORKSPACE_BY_ID__FAILURE');

export const getWorkspaceByIdActions = [
    getWorkspaceByIdRequest,
    getWorkspaceByIdSuccess,
    getWorkspaceByIdFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {number} meta.workspaceId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getWorkspaceById = (meta: GetWorkspaceById$Request, config?: GetWorkspaceById$Config) => {
    return {
        CALL_API: {
            types: getWorkspaceByIdActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/workspaces/${meta.workspaceId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetWorkspaceDetailsByIds$Request {
    userId: number;
    requestBody: Array<number>;
}

export interface GetWorkspaceDetailsByIds$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getWorkspaceDetailsByIdsRequest = createAction<PayloadData<void, GetWorkspaceDetailsByIds$Request>>('USER_WORKSPACES__GET_WORKSPACE_DETAILS_BY_IDS__REQUEST');
export const getWorkspaceDetailsByIdsSuccess = createAction<PayloadData<{ [key: string]: WorkspaceDetails; }, GetWorkspaceDetailsByIds$Request>>('USER_WORKSPACES__GET_WORKSPACE_DETAILS_BY_IDS__SUCCESS');
export const getWorkspaceDetailsByIdsFailure = createAction<PayloadData<Error, GetWorkspaceDetailsByIds$Request, true>>('USER_WORKSPACES__GET_WORKSPACE_DETAILS_BY_IDS__FAILURE');

export const getWorkspaceDetailsByIdsActions = [
    getWorkspaceDetailsByIdsRequest,
    getWorkspaceDetailsByIdsSuccess,
    getWorkspaceDetailsByIdsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {Array<number>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getWorkspaceDetailsByIds = (meta: GetWorkspaceDetailsByIds$Request, config?: GetWorkspaceDetailsByIds$Config) => {
    return {
        CALL_API: {
            types: getWorkspaceDetailsByIdsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/workspaces`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

